import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_ENABLE_PETITION_STRENGTH_TIPS = createFcmConfig('enable_petition_strength_tips', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
